<template>
  <!-- The resume itself, as the first page of its sheet, small. It is the same drawing as the editor's preview (ResumePreview), so it shows
       exactly what is in the resume. It is only drawn once the card is near the screen (a page can have 25), and until then, or for a resume
       with no content, the little drawing of its template stands in. -->
  <div ref="box" class="relative overflow-hidden rounded-lg bg-gray-100 dark:bg-[#161b22] aspect-[794/1123]" aria-hidden="true">
    <ResumePreview v-if="drawn" :content="content" :template="template" :picture-url="pictureUrl" class="absolute inset-x-0 top-0 pointer-events-none select-none" />
    <div v-else class="absolute inset-0 px-[18%] pt-4">
      <ResumeThumb :template="template" class="rounded-b-none shadow-md" />
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import ResumePreview from './editor/ResumePreview.vue'
import ResumeThumb from './ResumeThumb.vue'

const props = defineProps({
  content: { type: Object, default: null },
  template: { type: String, default: 'modern' },
  pictureUrl: { type: String, default: null },
})

const NEAR = '300px' // how far from the screen a card starts drawing, so it is ready as it scrolls in

const box = ref(null)
const near = ref(typeof IntersectionObserver === 'undefined') // without the observer, everything is drawn at once
const drawn = computed(() => near.value && Boolean(props.content?.settings))

let observer = null
onMounted(() => {
  if (typeof IntersectionObserver === 'undefined') return

  observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return
    near.value = true
    observer.disconnect() // drawn once, and kept
  }, { rootMargin: NEAR })
  observer.observe(box.value)
})
onBeforeUnmount(() => observer?.disconnect())
</script>
